import { useTheme } from 'styled-components';
export const useTrellisTheme = () => {
  return useTheme();
};